__turbopack_context__.v({
  "productHero": "product-hero-module-scss-module__jfJPpa__productHero",
  "productHeroContent": "product-hero-module-scss-module__jfJPpa__productHeroContent",
  "productHeroIcon": "product-hero-module-scss-module__jfJPpa__productHeroIcon",
  "productHeroPoints": "product-hero-module-scss-module__jfJPpa__productHeroPoints",
  "productHeroSuperTitle": "product-hero-module-scss-module__jfJPpa__productHeroSuperTitle",
  "productHeroTitle": "product-hero-module-scss-module__jfJPpa__productHeroTitle",
});
